(() => {
  const init = (root) => {
    if (!root || root.dataset.rslCoreProductBound) return;
    const image = root.querySelector('.rslr-product-media__image');
    const thumbs = Array.from(root.querySelectorAll('[data-rsl-core-product-thumb]'));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      if (!image) return;
      image.src = thumb.dataset.image;
      image.srcset = '';
      image.alt = thumb.dataset.alt || '';
      thumbs.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === thumb)));
      image.closest('.rslr-product-media')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    }));
    root.dataset.rslCoreProductBound = 'true';
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-rsl-core-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
